import ky, { type KyInstance } from 'ky';
import { API_BASE_URL } from '../config/constants';

const api: KyInstance = ky.create({
  prefixUrl: API_BASE_URL,
  credentials: 'include',
  hooks: {
    afterResponse: [
      (_request, _options, response) => {
        if (response.status === 401) {
          localStorage.removeItem('user');
          if (!window.location.pathname.includes('/login')) {
            window.location.href = '/login';
          }
        }
        if (response.status === 403) {
          window.location.href = '/';
        }
      },
    ],
  },
});

export function resolveApiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  // If API_BASE_URL is a path relative to origin (like /api), we prepend origin
  const base = API_BASE_URL.startsWith('http') ? `${API_BASE_URL}/` : window.location.origin;
  return new URL(path, base).toString();
}

export default api;
